export { default as ProductsElasticSearchCategoriesNavItem } from './ProductsElasticSearchCategoriesNavItem';
